export default __webpack_public_path__ + "static/media/tin.58204810.png";